import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TurnOffWeeklyDisclaimerPageRoutingModule } from './turn-off-weekly-disclaimer-routing.module';

import { TurnOffWeeklyDisclaimerPage } from './turn-off-weekly-disclaimer.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TurnOffWeeklyDisclaimerPageRoutingModule,
    ComponentsModule,
  ],
  declarations: [TurnOffWeeklyDisclaimerPage],
})
export class TurnOffWeeklyDisclaimerPageModule {}
